module.exports = __webpack_public_path__ + "static/media/intro-bench.670c6f2e.png";